<section
  class="cui-empty-state"
  [class.cui-empty-state--dashed]="variant() === 'dashed'"
  [class.cui-empty-state--solid]="variant() === 'solid'"
  [class.cui-empty-state--transparent]="variant() === 'transparent'">
  @if (icon()) {
    <span class="cui-empty-state__icon material-symbols-outlined" aria-hidden="true">
      {{ icon() }}
    </span>
  }

  <div class="cui-empty-state__copy">
    <h2 class="cui-empty-state__title">{{ title() }}</h2>

    @if (description()) {
      <p class="cui-empty-state__description">{{ description() }}</p>
    }
  </div>

  <div class="cui-empty-state__actions">
    <ng-content select="[empty-state-actions]" />
  </div>
</section>
